var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path2, _g10, _g11, _path3, _g12, _g13, _path4, _path5, _path6, _path7, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _path8, _g23, _g24, _g25, _path9, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _path10, _path11, _path12, _path13, _path14, _g36, _g37, _g38, _path15, _path16, _path17, _path18, _path19, _g39, _g40, _g41, _path20, _path21, _path22, _path23, _g42, _g43, _g44, _path24, _g45, _g46, _path25, _path26, _path27, _path28, _g47, _g48, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g49, _g50, _path37, _path38, _path39, _g51, _g52, _g53, _path40, _g54, _path41, _path42, _path43, _g55, _path44, _path45, _path46, _path47, _path48, _g56, _path49, _path50, _path51, _path52, _g57, _path53, _path54, _path55, _a, _path56, _g58, _path57, _path58, _path59;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoaEmail3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1298.35 1674.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .emails-disable-phase3{\n        fill: #edeef0 !important; \n      }\n      .emails-disable-phase3:hover {\n        pointer-events: none;\n        fill: #edeef0 !important; \n      }\n      .emails-disable-diamond-phase3{\n        fill: #07DABE !important\n      }\n      .emails-disable-diamond-phase3:hover {\n        pointer-events: none;\n        fill: #07DABE !important  \n      }\n      .emails-phase-3-1, .emails-phase-3-2, .emails-phase-3-3, .emails-phase-3-4 {\n        fill: #fff;\n      }\n\n      .emails-phase-3-1, .emails-phase-3-5, .emails-phase-3-6 {\n        stroke: rgba(0, 0, 0, 0);\n      }\n\n      .emails-phase-3-7 {\n        fill: url(#emails-phase-3-linear-gradient-3);\n      }\n\n      .emails-phase-3-7, .emails-phase-3-8, .emails-phase-3-9, .emails-phase-3-10, .emails-phase-3-11, .emails-phase-3-12, .emails-phase-3-4, .emails-phase-3-13 {\n        stroke: #008573;\n      }\n\n      .emails-phase-3-14, .emails-phase-3-15, .emails-phase-3-16, .emails-phase-3-3, .emails-phase-3-17, .emails-phase-3-18, .emails-phase-3-19, .emails-phase-3-20 {\n        stroke-width: 0px;\n      }\n\n      .emails-phase-3-14, .emails-phase-3-8, .emails-phase-3-11, .emails-phase-3-12 {\n        fill: #008573;\n      }\n\n      .emails-phase-3-2, .emails-phase-3-21 {\n        stroke: #4c535d;\n        stroke-width: .2px;\n      }\n\n      .emails-phase-3-22 {\n        fill: url(#emails-phase-3-linear-gradient-2);\n      }\n\n      .emails-phase-3-22, .emails-phase-3-23 {\n        stroke: #1071e5;\n      }\n\n      .emails-phase-3-21, .emails-phase-3-20 {\n        fill: #e81313;\n      }\n\n      .emails-phase-3-5 {\n        fill: #ffe342;\n      }\n\n      .emails-phase-3-8, .emails-phase-3-23 {\n        stroke-width: .05px;\n      }\n\n      .emails-phase-3-9, .emails-phase-3-11 {\n        stroke-width: 3px;\n      }\n\n      .emails-phase-3-9, .emails-phase-3-13 {\n        fill: none;\n      }\n\n      .emails-phase-3-10 {\n        fill: url(#emails-phase-3-linear-gradient);\n      }\n\n      .emails-phase-3-16 {\n        fill: #333;\n      }\n\n      .emails-phase-3-23, .emails-phase-3-19 {\n        fill: #1071e5;\n      }\n\n      .emails-phase-3-6 {\n        fill: #1a3378;\n      }\n\n      .emails-phase-3-17 {\n        fill: #2f5496;\n      }\n\n      .emails-phase-3-18 {\n        fill: #3a414a;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emails-phase-3-linear-gradient",
    x1: 767.62,
    y1: 1973.15,
    x2: 767.62,
    y2: 1804.49,
    gradientTransform: "translate(-184.11 2124.45) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008573"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emails-phase-3-linear-gradient-2",
    x1: 282.63,
    y1: 1938.16,
    x2: 282.63,
    y2: 1839.49,
    gradientTransform: "translate(-184.11 2124.45) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#cfe4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "emails-phase-3-linear-gradient-3",
    x1: 768.06,
    y1: 1199.94,
    x2: 768.06,
    y2: 1031.28,
    gradientTransform: "translate(-184.11 2124.45) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008573"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rect-8",
    className: "emails-phase-3-4",
    d: "M411.97,1426.45c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6h0v86.66c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-86.66Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ao",
    className: "emails-phase-3-18",
    d: "M437.28,1458.91l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM434.7,1452.18l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap",
    className: "emails-phase-3-18",
    d: "M445.42,1445.73c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM446.04,1447.36c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq",
    className: "emails-phase-3-18",
    d: "M460.57,1458.91h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar",
    className: "emails-phase-3-18",
    d: "M467.09,1443.22v-2.04h2.17v2.04h-2.17ZM467.09,1458.91v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as",
    className: "emails-phase-3-18",
    d: "M479.99,1449.2c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at",
    className: "emails-phase-3-18",
    d: "M489.83,1445.73c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM493.36,1451.23c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "au",
    className: "emails-phase-3-18",
    d: "M515.97,1446.07c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av",
    className: "emails-phase-3-18",
    d: "M529.21,1441.86c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM529.21,1457.28c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-2",
    "data-name": "ao",
    className: "emails-phase-3-18",
    d: "M552.64,1458.91l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM550.06,1452.18l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw",
    className: "emails-phase-3-18",
    d: "M570.02,1456.46c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM563.71,1455.31c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax",
    className: "emails-phase-3-18",
    d: "M586.05,1446c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM580.41,1457.41c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-2",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M594.4,1445.73c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM597.93,1451.23c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay",
    className: "emails-phase-3-18",
    d: "M609.13,1445.73c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az",
    className: "emails-phase-3-18",
    d: "M621.29,1447.43c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA",
    className: "emails-phase-3-18",
    d: "M639.15,1446l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aB",
    className: "emails-phase-3-18",
    d: "M650.01,1455.71c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC",
    className: "emails-phase-3-18",
    d: "M659.59,1445.73c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM659.52,1457.55c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ar-2",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M674.8,1443.22v-2.04h2.17v2.04h-2.17ZM674.8,1458.91v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-2",
    "data-name": "ay",
    className: "emails-phase-3-18",
    d: "M686.47,1445.73c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-3",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M693.74,1443.22v-2.04h2.17v2.04h-2.17ZM693.74,1458.91v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-2",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M701.48,1455.71c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-4",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M705.89,1443.22v-2.04h2.17v2.04h-2.17ZM705.89,1458.91v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-2",
    "data-name": "aw",
    className: "emails-phase-3-18",
    d: "M719.2,1456.46c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM712.89,1455.31c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-3",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M727.21,1455.71c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-3",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M736.79,1445.73c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM740.32,1451.23c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aB-4",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M467.46,1485.05c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD",
    className: "emails-phase-3-18",
    d: "M477.44,1476.76c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-4",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M490.61,1475.07c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM494.14,1480.57c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at-5",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M510.98,1475.07c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM514.51,1480.57c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE",
    className: "emails-phase-3-18",
    d: "M532.03,1476.76c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-3",
    "data-name": "aw",
    className: "emails-phase-3-18",
    d: "M547.65,1485.79c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM541.34,1484.64c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-5",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M553.29,1472.55v-2.04h2.17v2.04h-2.17ZM553.29,1488.24v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF",
    className: "emails-phase-3-18",
    d: "M558.65,1488.24v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aG",
    className: "emails-phase-3-18",
    d: "M568.29,1493.33c-2.58-2.85-4.41-6.25-4.41-11.48s1.9-8.56,4.41-11.34h2.1c-2.58,2.78-4.35,6.25-4.35,11.41s1.77,8.62,4.35,11.41h-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-2",
    "data-name": "as",
    className: "emails-phase-3-18",
    d: "M579.63,1478.53c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH",
    className: "emails-phase-3-18",
    d: "M584.93,1470.52c2.58,2.78,4.41,6.25,4.41,11.41s-1.83,8.62-4.41,11.41h-2.1c2.51-2.78,4.35-6.25,4.35-11.41s-1.83-8.62-4.35-11.41h2.1"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "as-3",
    "data-name": "as",
    className: "emails-phase-3-18",
    d: "M606.72,1478.53c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-6",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M616.57,1475.07c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM620.1,1480.57c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-3",
    "data-name": "ay",
    className: "emails-phase-3-18",
    d: "M631.3,1475.07c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-2",
    "data-name": "ap",
    className: "emails-phase-3-18",
    d: "M642.71,1475.07c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM643.32,1476.7c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC-2",
    "data-name": "aC",
    className: "emails-phase-3-18",
    d: "M664.1,1475.07c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM664.03,1486.88c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI",
    className: "emails-phase-3-18",
    d: "M676.59,1488.51c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-5",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M688.48,1485.05c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-4",
    "data-name": "as",
    className: "emails-phase-3-18",
    d: "M700.43,1478.53c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "rect-1",
    className: "emails-phase-3-4",
    d: "M411.97,6.5c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v86.66c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6V6.5Z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aJ",
    className: "emails-phase-3-18",
    d: "M520.66,55.65v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-4",
    "data-name": "ay",
    className: "emails-phase-3-18",
    d: "M533.15,42.47c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-6",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M540.42,39.96v-2.04h2.17v2.04h-2.17ZM540.42,55.65v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-6",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M548.16,52.45c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-7",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M552.57,39.96v-2.04h2.17v2.04h-2.17ZM552.57,55.65v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-4",
    "data-name": "aw",
    className: "emails-phase-3-18",
    d: "M565.88,53.2c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM559.57,52.05c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-7",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M573.89,52.45c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-7",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M583.47,42.47c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM587,47.97c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aK",
    className: "emails-phase-3-18",
    d: "M613.34,55.65l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL",
    className: "emails-phase-3-18",
    d: "M619.39,55.65v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM",
    className: "emails-phase-3-18",
    d: "M646.75,43.63c-.07,2.78-1.56,4.35-4.07,4.75l4.75,7.27h-2.58l-4.41-6.99h-5.23v6.99h-2.24v-16.84c5.98.2,13.92-1.43,13.78,4.82ZM635.21,46.89c4.07-.14,9.3.88,9.3-3.19s-5.43-2.85-9.3-3.06v6.25"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "rect-2",
    className: "emails-phase-3-10",
    d: "M578.13,153.95c3.39-1.67,7.37-1.67,10.76,0l160.36,79.02c1.46.73,2.06,2.51,1.33,3.97-.29.58-.75,1.04-1.33,1.33l-160.35,79.04c-3.4,1.67-7.38,1.67-10.77,0l-160.36-79.02c-1.46-.73-2.06-2.51-1.33-3.97.29-.58.75-1.04,1.33-1.33l160.36-79.04Z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aN",
    className: "emails-phase-3-3",
    d: "M531.95,240.45l.14-13.85-4.35,13.85h-2.51l-4.28-13.85.14,13.85h-3.12v-16.84h4.75l3.8,12.56,3.87-12.56h4.69v16.84h-3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO",
    className: "emails-phase-3-3",
    d: "M538.27,240.45v-16.84h3.53v14.12h9.03v2.72h-12.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP",
    className: "emails-phase-3-3",
    d: "M567.81,228.63c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM556.67,231.35c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aQ",
    className: "emails-phase-3-3",
    d: "M585.87,240.45h-3.6l-6.25-16.84h3.73l4.35,13.99c1.15-4.89,2.85-9.3,4.28-13.99h3.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR",
    className: "emails-phase-3-3",
    d: "M603.39,237.19c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM600.33,232.5c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS",
    className: "emails-phase-3-3",
    d: "M613.57,230.26c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT",
    className: "emails-phase-3-3",
    d: "M619.89,227.27c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM621.04,238.41c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU",
    className: "emails-phase-3-3",
    d: "M630.48,225.24v-2.51h3.4v2.51h-3.4ZM630.48,240.45v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV",
    className: "emails-phase-3-3",
    d: "M648.47,236.17c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW",
    className: "emails-phase-3-3",
    d: "M656.96,240.24c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-13",
    d: "M583.1,100.15l.3,37.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M583.6,100.17h-1v-.5h1v.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-12",
    d: "M583.5,152.71l-4.75-14.23,9.27-.07-4.52,14.3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "rect-3",
    className: "emails-phase-3-4",
    d: "M411.97,438.58c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v91.45c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-91.45Z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aX",
    className: "emails-phase-3-18",
    d: "M432.42,457.92c8.01-.48,14.67.54,14.46,8.28-.2,5.3-2.92,8.56-8.22,8.56h-6.25v-16.84ZM434.66,472.92c6.04.54,9.91-1.09,9.91-6.72s-4.07-6.86-9.91-6.45v13.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-2",
    "data-name": "au",
    className: "emails-phase-3-18",
    d: "M460.53,461.92c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY",
    className: "emails-phase-3-18",
    d: "M472.89,459.82v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC-3",
    "data-name": "aC",
    className: "emails-phase-3-18",
    d: "M492.24,461.58c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM492.17,473.4c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ",
    className: "emails-phase-3-18",
    d: "M506.77,463.69c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "b-2",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "au-3",
    "data-name": "au",
    className: "emails-phase-3-18",
    d: "M526.46,461.92c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-2",
    "data-name": "av",
    className: "emails-phase-3-18",
    d: "M539.71,457.71c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM539.71,473.13c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-3",
    "data-name": "ao",
    className: "emails-phase-3-18",
    d: "M563.13,474.76l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM560.55,468.03l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "c-2",
    "data-name": "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw-5",
    "data-name": "aw",
    className: "emails-phase-3-18",
    d: "M580.51,472.31c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM574.2,471.16c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-2",
    "data-name": "ax",
    className: "emails-phase-3-18",
    d: "M596.54,461.86c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM590.9,473.26c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-8",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M604.89,461.58c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM608.42,467.08c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-5",
    "data-name": "ay",
    className: "emails-phase-3-18",
    d: "M619.63,461.58c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-2",
    "data-name": "az",
    className: "emails-phase-3-18",
    d: "M631.78,463.28c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-2",
    "data-name": "aA",
    className: "emails-phase-3-18",
    d: "M649.64,461.86l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "az-3",
    "data-name": "az",
    className: "emails-phase-3-18",
    d: "M663.01,463.28c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-2",
    "data-name": "aZ",
    className: "emails-phase-3-18",
    d: "M676.46,463.69c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-9",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M683.59,461.58c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM687.12,467.08c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-6",
    "data-name": "aw",
    className: "emails-phase-3-18",
    d: "M699.95,472.31c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM693.64,471.16c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-8",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M707.96,471.57c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-10",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M717.54,461.58c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM721.07,467.08c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-5",
    "data-name": "as",
    className: "emails-phase-3-18",
    d: "M733.5,465.05c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw-7",
    "data-name": "aw",
    className: "emails-phase-3-18",
    d: "M436.84,501.65c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM430.52,500.49c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-6",
    "data-name": "ay",
    className: "emails-phase-3-18",
    d: "M448.79,490.92c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-3",
    "data-name": "ap",
    className: "emails-phase-3-18",
    d: "M460.19,490.92c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM460.8,492.55c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ap-4",
    "data-name": "ap",
    className: "emails-phase-3-18",
    d: "M480.56,490.92c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM481.17,492.55c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-11",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M495.16,490.92c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM498.69,496.42c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF-2",
    "data-name": "aF",
    className: "emails-phase-3-18",
    d: "M503.58,504.09v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-8",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M508.95,488.4v-2.04h2.17v2.04h-2.17ZM508.95,504.09v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-2",
    "data-name": "aq",
    className: "emails-phase-3-18",
    d: "M520.01,504.09h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-12",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M531.69,490.92c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM535.22,496.42c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-3",
    "data-name": "aZ",
    className: "emails-phase-3-18",
    d: "M546.22,493.02c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-6",
    "data-name": "as",
    className: "emails-phase-3-18",
    d: "M555.73,494.38c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ba",
    className: "emails-phase-3-18",
    d: "M578.95,504.09v-7.81h-9.1v7.81h-2.24v-16.84h2.24v7.13h9.1v-7.13h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-2",
    "data-name": "aY",
    className: "emails-phase-3-18",
    d: "M591.79,489.15v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aK-2",
    "data-name": "aK",
    className: "emails-phase-3-18",
    d: "M614.33,504.09l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL-2",
    "data-name": "aL",
    className: "emails-phase-3-18",
    d: "M620.37,504.09v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bb",
    className: "emails-phase-3-18",
    d: "M639.86,487.25c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM642.1,495.74c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-8",
    "data-name": "aw",
    className: "emails-phase-3-18",
    d: "M663.69,501.65c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM657.38,500.49c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-4",
    "data-name": "az",
    className: "emails-phase-3-18",
    d: "M674.22,492.61c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc",
    className: "emails-phase-3-18",
    d: "M689.63,504.09l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-9",
    "data-name": "aw",
    className: "emails-phase-3-18",
    d: "M701.72,501.65c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM695.4,500.49c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-3",
    "data-name": "ax",
    className: "emails-phase-3-18",
    d: "M717.74,491.19c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM712.11,502.6c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-13",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M726.09,490.92c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM729.63,496.42c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd",
    className: "emails-phase-3-18",
    d: "M735.13,504.09v-2.58h2.31v2.58h-2.31"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "rect-10",
    className: "emails-phase-3-22",
    d: "M.5,192.29c0-3.31,2.69-6,6-6h184.03c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-86.67Z"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "be",
    className: "emails-phase-3-3",
    d: "M39.23,229.08c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-2",
    "data-name": "aR",
    className: "emails-phase-3-3",
    d: "M56.61,238.18c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM53.55,233.5c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-3",
    "data-name": "aR",
    className: "emails-phase-3-3",
    d: "M70.19,238.18c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM67.13,233.5c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bf",
    className: "emails-phase-3-3",
    d: "M79.63,224.6c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84ZM83.16,232.82c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg",
    className: "emails-phase-3-3",
    d: "M102.04,230.78c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh",
    className: "emails-phase-3-3",
    d: "M118.2,239.13c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM114.94,239.34c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi",
    className: "emails-phase-3-3",
    d: "M132.05,232.07c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-4",
    "data-name": "aR",
    className: "emails-phase-3-3",
    d: "M148.89,238.18c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM145.83,233.5c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bj",
    className: "emails-phase-3-3",
    d: "M169.05,229.08c0,5.3-5.7,5.84-7.54,9.57h7.81v2.78h-11.81c-.41-6.86,6.72-6.79,8.15-12.22.07-1.49-.81-2.1-2.24-2.17-1.56,0-2.17.95-2.38,2.31l-3.33-.2c.34-3.06,2.17-4.75,5.7-4.75s5.64,1.49,5.64,4.69"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "emails-disable-phase3",
    d: "M1017.3,183.4c0-3.31,2.69-6,6-6h228c3.31,0,6,2.69,6,6v115.33c0,3.31-2.69,6-6,6h-228c-3.31,0-6-2.69-6-6v-115.33Z"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bk",
    className: "emails-phase-3-18",
    d: "M1092.71,193.49c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-4",
    "data-name": "aC",
    className: "emails-phase-3-18",
    d: "M1102.69,192.47c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM1102.62,204.28c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-2",
    "data-name": "aE",
    className: "emails-phase-3-18",
    d: "M1123.74,194.17c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-3",
    "data-name": "aE",
    className: "emails-phase-3-18",
    d: "M1144.04,194.17c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-14",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M1156.88,192.47c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM1160.41,197.97c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-7",
    "data-name": "ay",
    className: "emails-phase-3-18",
    d: "M1171.61,192.47c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-9",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M1181.25,202.45c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-7",
    "data-name": "as",
    className: "emails-phase-3-18",
    d: "M1193.2,195.93c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "as-8",
    "data-name": "as",
    className: "emails-phase-3-18",
    d: "M1038.22,225.26c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-2",
    "data-name": "aI",
    className: "emails-phase-3-18",
    d: "M1046.98,235.25c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl",
    className: "emails-phase-3-18",
    d: "M1062.66,221.8c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM1062.12,233.62c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-4",
    "data-name": "aE",
    className: "emails-phase-3-18",
    d: "M1082.69,223.5c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-9",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M1090.37,219.29v-2.04h2.17v2.04h-2.17ZM1090.37,234.97v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-10",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M1098.11,231.78c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-11",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M1104.9,231.78c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-15",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M1114.47,221.8c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM1118,227.3c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-5",
    "data-name": "ap",
    className: "emails-phase-3-18",
    d: "M1127.03,221.8c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM1127.64,223.43c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "d-2",
    "data-name": "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aB-12",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M1145.64,231.78c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-5",
    "data-name": "aC",
    className: "emails-phase-3-18",
    d: "M1155.21,221.8c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM1155.14,233.62c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aX-2",
    "data-name": "aX",
    className: "emails-phase-3-18",
    d: "M1170.83,218.14c8.01-.48,14.67.54,14.46,8.28-.2,5.3-2.92,8.56-8.22,8.56h-6.25v-16.84ZM1173.07,233.14c6.04.54,9.91-1.09,9.91-6.72s-4.07-6.86-9.91-6.45v13.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-4",
    "data-name": "au",
    className: "emails-phase-3-18",
    d: "M1198.94,222.14c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-3",
    "data-name": "aY",
    className: "emails-phase-3-18",
    d: "M1211.3,220.04v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC-6",
    "data-name": "aC",
    className: "emails-phase-3-18",
    d: "M1230.65,221.8c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM1230.58,233.62c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-4",
    "data-name": "aZ",
    className: "emails-phase-3-18",
    d: "M1245.18,223.91c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "b-3",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "au-5",
    "data-name": "au",
    className: "emails-phase-3-18",
    d: "M1064.33,251.47c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-3",
    "data-name": "av",
    className: "emails-phase-3-18",
    d: "M1077.57,247.26c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM1077.57,262.68c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-4",
    "data-name": "ao",
    className: "emails-phase-3-18",
    d: "M1100.99,264.31l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM1098.41,257.59l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "c-3",
    "data-name": "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw-10",
    "data-name": "aw",
    className: "emails-phase-3-18",
    d: "M1118.38,261.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM1112.06,260.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-4",
    "data-name": "ax",
    className: "emails-phase-3-18",
    d: "M1134.4,251.41c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM1128.76,262.81c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-16",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M1142.75,251.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM1146.28,256.64c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-8",
    "data-name": "ay",
    className: "emails-phase-3-18",
    d: "M1157.49,251.14c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-5",
    "data-name": "az",
    className: "emails-phase-3-18",
    d: "M1169.64,252.83c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-3",
    "data-name": "aA",
    className: "emails-phase-3-18",
    d: "M1187.5,251.41l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bm",
    className: "emails-phase-3-18",
    d: "M1201.22,248.42c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-7",
    "data-name": "aC",
    className: "emails-phase-3-18",
    d: "M1207.94,251.14c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM1207.87,262.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-5",
    "data-name": "aZ",
    className: "emails-phase-3-18",
    d: "M1222.47,253.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bm-2",
    "data-name": "bm",
    className: "emails-phase-3-18",
    d: "M1062.09,277.75c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-3",
    "data-name": "aI",
    className: "emails-phase-3-18",
    d: "M1067.72,293.91c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-6",
    "data-name": "aZ",
    className: "emails-phase-3-18",
    d: "M1083.34,282.57c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-13",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M1087.68,290.45c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-2",
    "data-name": "aD",
    className: "emails-phase-3-18",
    d: "M1097.67,282.17c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-17",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M1110.84,280.47c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM1114.37,285.97c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-7",
    "data-name": "aZ",
    className: "emails-phase-3-18",
    d: "M1125.37,282.57c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw-11",
    "data-name": "aw",
    className: "emails-phase-3-18",
    d: "M1142.07,291.2c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM1135.76,290.04c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-5",
    "data-name": "aE",
    className: "emails-phase-3-18",
    d: "M1160.34,282.17c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-18",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M1173.17,280.47c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM1176.7,285.97c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-9",
    "data-name": "ay",
    className: "emails-phase-3-18",
    d: "M1187.91,280.47c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-6",
    "data-name": "ap",
    className: "emails-phase-3-18",
    d: "M1199.31,280.47c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM1199.92,282.1c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-9",
    "data-name": "as",
    className: "emails-phase-3-18",
    d: "M1216.29,283.93c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-23",
    d: "M237.04,236.13h-23.62v-1h23.63v1ZM415.11,236.13h-16.86v-1h16.87v1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-19",
    d: "M415.6,235.63l.07.5h-.57v-1h.57l-.07.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-23",
    d: "M415.64,235.63l.06.52h-.62v-1.05h.62l-.06.53ZM415.14,235.15v.95h.5l-.05-.47.04-.48h-.49Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-19",
    d: "M212.92,240.25l-14.27-4.62,14.27-4.64v9.26Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-23",
    d: "M213.42,240.95l-16.4-5.32,16.4-5.33v10.65ZM200.27,235.63l12.15,3.94v-7.9l-12.15,3.96Z"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bn",
    className: "emails-phase-3-15",
    d: "M294.6,214.03c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM283.46,216.75c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo",
    className: "emails-phase-3-15",
    d: "M308.45,222.59c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM305.39,217.9c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp",
    className: "emails-phase-3-15",
    d: "M318.16,225.85h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq",
    className: "emails-phase-3-15",
    d: "M324.74,210.64v-2.51h3.4v2.51h-3.4ZM324.74,225.85v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "br",
    className: "emails-phase-3-15",
    d: "M339.14,216.48c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo-2",
    "data-name": "bo",
    className: "emails-phase-3-15",
    d: "M355.98,222.59c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM352.92,217.9c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bs",
    className: "emails-phase-3-15",
    d: "M246.08,252.87c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM242.82,253.08c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt",
    className: "emails-phase-3-15",
    d: "M259.8,242.01c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu",
    className: "emails-phase-3-15",
    d: "M271.48,242.01c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM272.63,253.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bn-2",
    "data-name": "bn",
    className: "emails-phase-3-15",
    d: "M303.46,243.37c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM292.32,246.08c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo-3",
    "data-name": "bo",
    className: "emails-phase-3-15",
    d: "M317.31,251.92c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM314.25,247.24c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "br-2",
    "data-name": "br",
    className: "emails-phase-3-15",
    d: "M327.63,245.81c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bv",
    className: "emails-phase-3-15",
    d: "M337.68,255.45c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bw",
    className: "emails-phase-3-15",
    d: "M355.94,242.01c3.53,0,4.75,2.92,4.75,6.65s-1.29,6.72-4.96,6.79c-2.04.07-3.12-1.02-3.94-2.38l-.14,2.1h-3.26l.07-17.72h3.4v7.06c.75-1.56,1.97-2.51,4.07-2.51ZM354.52,253.14c2.1,0,2.72-1.83,2.72-4.48s-.48-4.28-2.65-4.28-2.78,1.9-2.78,4.41.54,4.35,2.72,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx",
    className: "emails-phase-3-15",
    d: "M376.59,244.52c-3.6.61-1.9,6.79-2.31,10.66h-3.33v-7.27c.07-1.83-.34-3.33-1.97-3.4-3.6.68-1.83,6.79-2.24,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.68-3.6,6.86-3.8,7.33,0,.88-1.49,1.63-2.92,4.01-2.85,5.57.07,3.46,7.88,3.87,13.17h-3.33v-7.27c-.07-1.7-.34-3.26-1.97-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-2",
    "data-name": "bq",
    className: "emails-phase-3-15",
    d: "M385.07,239.97v-2.51h3.4v2.51h-3.4ZM385.07,255.18v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "by",
    className: "emails-phase-3-15",
    d: "M397.98,254.98c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M806.86,236.13h-54.96v-1h54.96v1ZM1000.4,236.13h-39.07v-1h39.07v1Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-14",
    d: "M751.92,236.13h-.57l.06-.5-.05-.5h.57v1Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M751.95,236.15h-.63l.06-.52-.06-.53h.63v1.05ZM751.38,235.15l.05.48-.05.47h.52v-.95h-.52Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-14",
    d: "M1015.17,235.63l-14.27,4.62v-9.26l14.27,4.64Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M1016.78,235.63l-16.38,5.32v-10.65l16.38,5.33ZM1001.4,239.57l12.15-3.94-12.15-3.95v7.89Z"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bz",
    className: "emails-phase-3-15",
    d: "M840.75,225.85l-1.49-4.28h-6.38l-1.49,4.28h-3.53l6.11-16.84h4.14l6.11,16.84h-3.46ZM838.51,218.92l-2.44-7.33c-.68,2.58-1.63,4.89-2.44,7.33h4.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bA",
    className: "emails-phase-3-15",
    d: "M853.99,212.68c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM852.56,223.81c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bA-2",
    "data-name": "bA",
    className: "emails-phase-3-15",
    d: "M868.86,212.68c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM867.43,223.81c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB",
    className: "emails-phase-3-15",
    d: "M883.73,215.66c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC",
    className: "emails-phase-3-15",
    d: "M891.54,212.68c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM891.47,223.81c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp-2",
    "data-name": "bp",
    className: "emails-phase-3-15",
    d: "M907.63,225.85h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo-4",
    "data-name": "bo",
    className: "emails-phase-3-15",
    d: "M925.08,222.59c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM922.02,217.9c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-2",
    "data-name": "bu",
    className: "emails-phase-3-15",
    d: "M932.07,212.68c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM933.23,223.81c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bD",
    className: "emails-phase-3-15",
    d: "M822.55,255.18h-3.53l-2.65-10.52-2.72,10.52h-3.53l-3.33-12.9h3.12l2.17,9.85c.61-3.53,1.63-6.59,2.44-9.85h3.6l2.51,9.85,2.17-9.85h3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-3",
    "data-name": "bq",
    className: "emails-phase-3-15",
    d: "M827.57,239.97v-2.51h3.4v2.51h-3.4ZM827.57,255.18v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "by-2",
    "data-name": "by",
    className: "emails-phase-3-15",
    d: "M840.48,254.98c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE",
    className: "emails-phase-3-15",
    d: "M848.49,244.52c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bF",
    className: "emails-phase-3-15",
    d: "M875.31,250.9c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE-2",
    "data-name": "bE",
    className: "emails-phase-3-15",
    d: "M883.73,244.52c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs-2",
    "data-name": "bs",
    className: "emails-phase-3-15",
    d: "M899.89,252.87c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM896.63,253.08c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-2",
    "data-name": "bt",
    className: "emails-phase-3-15",
    d: "M913.61,242.01c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bG",
    className: "emails-phase-3-15",
    d: "M932.55,254.77c.75,5.98-8.15,7.2-11.14,3.53-.27-.41-.41-.88-.54-1.43l3.33-.41c.2,1.09,1.09,1.63,2.31,1.7,2.72,0,2.85-2.51,2.72-5.36-.75,1.49-2.04,2.38-4.14,2.38-3.6,0-4.75-2.92-4.75-6.59s1.22-6.52,4.96-6.59c2.04,0,3.12.95,4.01,2.31l.14-2.04h3.19l-.07,12.49ZM926.44,252.8c2.17,0,2.78-1.83,2.78-4.28s-.61-4.21-2.72-4.21-2.65,1.97-2.72,4.28c0,2.44.61,4.21,2.65,4.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo-5",
    "data-name": "bo",
    className: "emails-phase-3-15",
    d: "M946.74,251.92c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM943.69,247.24c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "br-3",
    "data-name": "br",
    className: "emails-phase-3-15",
    d: "M957.06,245.81c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M582.63,415.69h-1v-24.72h1v24.72ZM584.01,332.29h-1v-14.87h1v14.87Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M584,317.45h-1v-3.53h1v3.53Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-14",
    d: "M582.13,430.45l-4.63-14.26h9.27l-4.64,14.26Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M582.13,432.08l-5.32-16.4h10.65l-5.33,16.4ZM578.18,416.68l3.95,12.16,3.95-12.16h-7.9Z"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "K-2",
    "data-name": "K"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bz-2",
    "data-name": "bz",
    className: "emails-phase-3-15",
    d: "M540.16,351.86l-1.49-4.28h-6.38l-1.49,4.28h-3.53l6.11-16.84h4.14l6.11,16.84h-3.46ZM537.92,344.93l-2.44-7.33c-.68,2.58-1.63,4.89-2.44,7.33h4.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bA-3",
    "data-name": "bA",
    className: "emails-phase-3-15",
    d: "M553.4,338.68c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM551.98,349.82c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bA-4",
    "data-name": "bA",
    className: "emails-phase-3-15",
    d: "M568.27,338.68c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM566.85,349.82c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-2",
    "data-name": "bB",
    className: "emails-phase-3-15",
    d: "M583.14,341.67c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-2",
    "data-name": "bC",
    className: "emails-phase-3-15",
    d: "M590.95,338.68c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM590.88,349.82c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp-3",
    "data-name": "bp",
    className: "emails-phase-3-15",
    d: "M607.04,351.86h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo-6",
    "data-name": "bo",
    className: "emails-phase-3-15",
    d: "M624.49,348.6c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM621.44,343.91c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-3",
    "data-name": "bu",
    className: "emails-phase-3-15",
    d: "M631.49,338.68c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM632.64,349.82c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bH",
    className: "emails-phase-3-15",
    d: "M507.81,365.84c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-3",
    "data-name": "bC",
    className: "emails-phase-3-15",
    d: "M515.14,368.02c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM515.07,379.15c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-3",
    "data-name": "bB",
    className: "emails-phase-3-15",
    d: "M531.71,371.01c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bI",
    className: "emails-phase-3-15",
    d: "M540.47,364.35c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84ZM544,372.57c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-4",
    "data-name": "bB",
    className: "emails-phase-3-15",
    d: "M564.3,371.01c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-4",
    "data-name": "bC",
    className: "emails-phase-3-15",
    d: "M572.11,368.02c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM572.04,379.15c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-4",
    "data-name": "bu",
    className: "emails-phase-3-15",
    d: "M585.49,368.02c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM586.64,379.15c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bv-2",
    "data-name": "bv",
    className: "emails-phase-3-15",
    d: "M600.15,381.46c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bF-2",
    "data-name": "bF",
    className: "emails-phase-3-15",
    d: "M622.15,376.91c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "by-3",
    "data-name": "by",
    className: "emails-phase-3-15",
    d: "M630.64,380.99c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-4",
    "data-name": "bq",
    className: "emails-phase-3-15",
    d: "M632.61,365.98v-2.51h3.4v2.51h-3.4ZM632.61,381.19v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-5",
    "data-name": "bC",
    className: "emails-phase-3-15",
    d: "M645.17,368.02c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM645.1,379.15c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-3",
    "data-name": "bt",
    className: "emails-phase-3-15",
    d: "M661.74,368.02c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "rect-5",
    className: "emails-phase-3-4",
    d: "M411.97,779.23c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6h0v-86.67Z"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "j-2",
    "data-name": "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aJ-2",
    "data-name": "aJ",
    className: "emails-phase-3-18",
    d: "M482.06,828.38v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-10",
    "data-name": "ay",
    className: "emails-phase-3-18",
    d: "M494.55,815.21c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-10",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M501.82,812.7v-2.04h2.17v2.04h-2.17ZM501.82,828.38v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-14",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M509.56,825.19c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-11",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M513.97,812.7v-2.04h2.17v2.04h-2.17ZM513.97,828.38v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-12",
    "data-name": "aw",
    className: "emails-phase-3-18",
    d: "M527.28,825.94c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM520.96,824.78c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-15",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M535.29,825.19c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-19",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M544.87,815.21c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM548.4,820.71c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bk-2",
    "data-name": "bk",
    className: "emails-phase-3-18",
    d: "M572.84,816.23c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-20",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M582.82,815.21c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM586.35,820.71c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-8",
    "data-name": "aZ",
    className: "emails-phase-3-18",
    d: "M597.35,817.32c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-16",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M601.7,825.19c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-12",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M606.11,812.7v-2.04h2.17v2.04h-2.17ZM606.11,828.38v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm-3",
    "data-name": "bm",
    className: "emails-phase-3-18",
    d: "M616.71,812.49c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-13",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M618.27,812.7v-2.04h2.17v2.04h-2.17ZM618.27,828.38v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-6",
    "data-name": "az",
    className: "emails-phase-3-18",
    d: "M628.52,816.91c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-13",
    "data-name": "aw",
    className: "emails-phase-3-18",
    d: "M643.8,825.94c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM637.48,824.78c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-17",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M651.81,825.19c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-14",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M656.22,812.7v-2.04h2.17v2.04h-2.17ZM656.22,828.38v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-8",
    "data-name": "aC",
    className: "emails-phase-3-18",
    d: "M666.75,815.21c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM666.68,827.03c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-11",
    "data-name": "ay",
    className: "emails-phase-3-18",
    d: "M681.48,815.21c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-13",
    d: "M583.1,537.03l.63,49"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M583.6,537.05h-1v-.52h1v.52Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-12",
    d: "M583.92,600.79l-4.8-14.2,9.25-.13-4.45,14.33Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "rect-6",
    className: "emails-phase-3-7",
    d: "M578.56,927.15c3.4-1.67,7.38-1.67,10.77,0l160.36,79.04c1.46.73,2.06,2.51,1.33,3.97-.29.58-.75,1.04-1.33,1.33l-160.37,79.03c-3.4,1.67-7.38,1.67-10.77,0l-160.35-79.03c-1.46-.73-2.06-2.51-1.33-3.97.29-.58.75-1.04,1.33-1.33l160.36-79.04Z"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bJ",
    className: "emails-phase-3-3",
    d: "M473.21,1005.17c0,3.6,1.43,5.91,4.96,5.98,2.51.07,3.67-1.49,4.41-3.19l3.06,1.15c-1.15,2.85-3.46,4.82-7.47,4.82-5.57,0-8.15-3.12-8.49-8.76-.48-7.47,7.4-10.59,13.31-7.27,1.22.68,1.97,1.97,2.44,3.4l-3.12.81c-.54-1.7-2.04-2.78-4.21-2.78-3.53,0-4.82,2.31-4.89,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-5",
    "data-name": "aR",
    className: "emails-phase-3-3",
    d: "M498.81,1010.4c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM495.76,1005.72c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-2",
    "data-name": "aS",
    className: "emails-phase-3-3",
    d: "M509,1003.48c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-2",
    "data-name": "aW",
    className: "emails-phase-3-3",
    d: "M517.14,1013.46c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-2",
    "data-name": "aU",
    className: "emails-phase-3-3",
    d: "M519.11,998.45v-2.51h3.4v2.51h-3.4ZM519.11,1013.66v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bK",
    className: "emails-phase-3-3",
    d: "M532.42,998.31c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-3",
    "data-name": "aU",
    className: "emails-phase-3-3",
    d: "M533.98,998.45v-2.51h3.4v2.51h-3.4ZM533.98,1013.66v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-2",
    "data-name": "aV",
    className: "emails-phase-3-3",
    d: "M551.98,1009.38c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh-2",
    "data-name": "bh",
    className: "emails-phase-3-3",
    d: "M561.69,1011.35c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM558.43,1011.56c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-3",
    "data-name": "aW",
    className: "emails-phase-3-3",
    d: "M574.05,1013.46c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-4",
    "data-name": "aU",
    className: "emails-phase-3-3",
    d: "M576.02,998.45v-2.51h3.4v2.51h-3.4ZM576.02,1013.66v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bL",
    className: "emails-phase-3-3",
    d: "M588.58,1000.49c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM588.51,1011.62c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bM",
    className: "emails-phase-3-3",
    d: "M605.14,1000.49c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aQ-2",
    "data-name": "aQ",
    className: "emails-phase-3-3",
    d: "M627.62,1013.66h-3.6l-6.25-16.84h3.73l4.35,13.99c1.15-4.89,2.85-9.3,4.28-13.99h3.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-6",
    "data-name": "aR",
    className: "emails-phase-3-3",
    d: "M645.14,1010.4c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM642.08,1005.72c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-3",
    "data-name": "aS",
    className: "emails-phase-3-3",
    d: "M655.32,1003.48c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT-2",
    "data-name": "aT",
    className: "emails-phase-3-3",
    d: "M661.64,1000.49c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM662.79,1011.62c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-5",
    "data-name": "aU",
    className: "emails-phase-3-3",
    d: "M672.23,998.45v-2.51h3.4v2.51h-3.4ZM672.23,1013.66v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-3",
    "data-name": "aV",
    className: "emails-phase-3-3",
    d: "M690.22,1009.38c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-4",
    "data-name": "aW",
    className: "emails-phase-3-3",
    d: "M698.71,1013.46c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-13",
    d: "M583.1,872.9l.6,38.26"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M583.6,872.9l-1,.02v-.52h1v.5Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-12",
    d: "M583.92,925.92l-4.86-14.2,9.27-.13-4.41,14.33Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M99.02,1002.82l.07.88.2.84.32.8.45.72.57.66.65.56.73.45.8.32.83.2.88.07h116.4v1h-116.42l-1-.1-1-.23-.93-.4-.87-.52-.77-.66-.67-.8-.53-.86-.4-.94-.23-1-.08-1V301.81h1v701.01ZM415.55,1008.34v1h-52.45v-1h52.45Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-14",
    d: "M416.05,1008.85l.05.5h-.57v-1h.57l-.05.5Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M416.07,1008.85l.06.5h-.62v-1.03h.63l-.07.53ZM415.57,1008.35v.97h.5l-.05-.48.06-.5h-.51Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-14",
    d: "M103.16,301.35h-9.26l4.62-14.27,4.64,14.27Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M103.85,301.85h-10.65l5.32-16.4,5.33,16.4ZM94.58,300.85h7.9l-3.96-12.16-3.94,12.16Z"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bN",
    className: "emails-phase-3-15",
    d: "M232.81,1013.73l-7.33-12.97c.41,3.94.14,8.69.2,12.97h-3.12v-16.84h4.01l7.47,13.1c-.41-3.94-.14-8.76-.2-13.1h3.12v16.84h-4.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-6",
    "data-name": "bC",
    className: "emails-phase-3-15",
    d: "M245.99,1000.56c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM245.92,1011.69c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "by-4",
    "data-name": "by",
    className: "emails-phase-3-15",
    d: "M261.2,1013.53c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bF-3",
    "data-name": "bF",
    className: "emails-phase-3-15",
    d: "M281.16,1009.45c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo-7",
    "data-name": "bo",
    className: "emails-phase-3-15",
    d: "M294.4,1010.47c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM291.34,1005.78c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-5",
    "data-name": "bB",
    className: "emails-phase-3-15",
    d: "M304.59,1003.54c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "by-5",
    "data-name": "by",
    className: "emails-phase-3-15",
    d: "M312.73,1013.53c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-5",
    "data-name": "bq",
    className: "emails-phase-3-15",
    d: "M314.7,998.52v-2.51h3.4v2.51h-3.4ZM314.7,1013.73v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bH-2",
    "data-name": "bH",
    className: "emails-phase-3-15",
    d: "M328.01,998.38c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-6",
    "data-name": "bq",
    className: "emails-phase-3-15",
    d: "M329.57,998.52v-2.51h3.4v2.51h-3.4ZM329.57,1013.73v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo-8",
    "data-name": "bo",
    className: "emails-phase-3-15",
    d: "M347.23,1010.47c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM344.17,1005.78c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-5",
    "data-name": "bu",
    className: "emails-phase-3-15",
    d: "M354.22,1000.56c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM355.38,1011.69c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M948.7,1009.35h-199.77v-1h199.8l-.03,1ZM1292.8,240.65l1,.23.94.4.87.52.78.67.67.77.53.86.4.95.23,1,.1,1v755.8l-.1,1-.23,1-.4.94-.52.87-.67.8-.77.65-.86.53-.94.4-1,.23-1,.1h-96.4v-1h96.37l.88-.08.84-.2.78-.33.74-.46.65-.56.56-.66.46-.73.32-.8.2-.85.07-.88V247.08l-.08-.88-.2-.83-.33-.8-.47-.74-.56-.65-.65-.56-.74-.45-.8-.33-.83-.22-.88-.06h-17.6v-1h17.64l1,.09ZM748.93,1009.35h-3.5v-1h3.5v1Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-14",
    d: "M1273.67,245.7l-14.27-4.63,14.27-4.64v9.27Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M1274.17,246.39l-16.38-5.32,16.37-5.33v10.65ZM1261.02,241.07l12.15,3.94v-7.9l-12.15,3.96Z"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bn-3",
    "data-name": "bn",
    className: "emails-phase-3-15",
    d: "M965.01,1001.91c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM953.87,1004.63c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo-9",
    "data-name": "bo",
    className: "emails-phase-3-15",
    d: "M978.86,1010.47c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM975.81,1005.78c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp-4",
    "data-name": "bp",
    className: "emails-phase-3-15",
    d: "M988.57,1013.73h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-7",
    "data-name": "bq",
    className: "emails-phase-3-15",
    d: "M995.16,998.52v-2.51h3.4v2.51h-3.4ZM995.16,1013.73v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "br-4",
    "data-name": "br",
    className: "emails-phase-3-15",
    d: "M1009.55,1004.36c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo-10",
    "data-name": "bo",
    className: "emails-phase-3-15",
    d: "M1026.39,1010.47c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM1023.34,1005.78c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bs-3",
    "data-name": "bs",
    className: "emails-phase-3-15",
    d: "M1043.23,1011.42c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM1039.97,1011.62c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-4",
    "data-name": "bt",
    className: "emails-phase-3-15",
    d: "M1056.95,1000.56c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-6",
    "data-name": "bu",
    className: "emails-phase-3-15",
    d: "M1068.63,1000.56c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM1069.78,1011.69c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bn-4",
    "data-name": "bn",
    className: "emails-phase-3-15",
    d: "M1100.61,1001.91c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02ZM1089.47,1004.63c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo-11",
    "data-name": "bo",
    className: "emails-phase-3-15",
    d: "M1114.46,1010.47c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM1111.4,1005.78c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "br-5",
    "data-name": "br",
    className: "emails-phase-3-15",
    d: "M1124.78,1004.36c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bv-3",
    "data-name": "bv",
    className: "emails-phase-3-15",
    d: "M1134.83,1014c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bw-2",
    "data-name": "bw",
    className: "emails-phase-3-15",
    d: "M1153.1,1000.56c3.53,0,4.75,2.92,4.75,6.65s-1.29,6.72-4.96,6.79c-2.04.07-3.12-1.02-3.94-2.38l-.14,2.1h-3.26l.07-17.72h3.4v7.06c.75-1.56,1.97-2.51,4.07-2.51ZM1151.67,1011.69c2.1,0,2.72-1.83,2.72-4.48s-.48-4.28-2.65-4.28-2.78,1.9-2.78,4.41.54,4.35,2.72,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx-2",
    "data-name": "bx",
    className: "emails-phase-3-15",
    d: "M1173.74,1003.07c-3.6.61-1.9,6.79-2.31,10.66h-3.33v-7.27c.07-1.83-.34-3.33-1.97-3.4-3.6.68-1.83,6.79-2.24,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.68-3.6,6.86-3.8,7.33,0,.88-1.49,1.63-2.92,4.01-2.85,5.57.07,3.46,7.88,3.87,13.17h-3.33v-7.27c-.07-1.7-.34-3.26-1.97-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-8",
    "data-name": "bq",
    className: "emails-phase-3-15",
    d: "M1182.23,998.52v-2.51h3.4v2.51h-3.4ZM1182.23,1013.73v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "by-6",
    "data-name": "by",
    className: "emails-phase-3-15",
    d: "M1195.13,1013.53c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "rect-7",
    className: "emails-phase-3-4",
    d: "M412.82,1206.45c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v86.66c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-86.66Z"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bO",
    className: "emails-phase-3-18",
    d: "M445.53,1240.66v6.25h9.37v1.9h-9.37v6.79h-2.24v-16.84h11.88v1.9h-9.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-15",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M457.75,1239.91v-2.04h2.17v2.04h-2.17ZM457.75,1255.59v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-12",
    "data-name": "ay",
    className: "emails-phase-3-18",
    d: "M469.43,1242.42c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-14",
    "data-name": "aw",
    className: "emails-phase-3-18",
    d: "M484.64,1253.15c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM478.32,1251.99c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF-3",
    "data-name": "aF",
    className: "emails-phase-3-18",
    d: "M490.28,1255.59v-17.72h2.17v17.72h-2.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "as-10",
    "data-name": "as",
    className: "emails-phase-3-18",
    d: "M509.97,1245.88c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-18",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M517.03,1252.4c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-21",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M526.6,1242.42c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM530.13,1247.92c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bP",
    className: "emails-phase-3-18",
    d: "M541.2,1242.42c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM540.66,1254.24c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-11",
    "data-name": "as",
    className: "emails-phase-3-18",
    d: "M556.14,1245.88c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bl-2",
    "data-name": "bl",
    className: "emails-phase-3-18",
    d: "M573.79,1242.42c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM573.25,1254.24c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-22",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M586.36,1242.42c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM589.89,1247.92c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm-4",
    "data-name": "bm",
    className: "emails-phase-3-18",
    d: "M600,1239.7c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-9",
    "data-name": "aC",
    className: "emails-phase-3-18",
    d: "M606.73,1242.42c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM606.66,1254.24c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-9",
    "data-name": "aZ",
    className: "emails-phase-3-18",
    d: "M621.26,1244.53c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-23",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M628.39,1242.42c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM631.92,1247.92c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bQ",
    className: "emails-phase-3-18",
    d: "M651.68,1255.86c-5.57,0-8.22-3.26-8.49-8.76-.34-7.27,6.79-10.46,13.1-7.54,1.15.54,1.97,1.7,2.51,2.92l-2.17.61c-.88-1.7-2.51-2.72-5.16-2.72-4.14,0-5.98,2.65-5.98,6.72s1.97,6.79,6.18,6.86c2.38,0,4.21-.75,5.36-1.83v-3.06h-5.02v-1.9h7.13v5.84c-1.7,1.7-4.14,2.85-7.47,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-10",
    "data-name": "aC",
    className: "emails-phase-3-18",
    d: "M667.77,1242.42c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM667.7,1254.24c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bR",
    className: "emails-phase-3-18",
    d: "M675.65,1250.03v-1.9h5.98v1.9h-5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL-3",
    "data-name": "aL",
    className: "emails-phase-3-18",
    d: "M684.68,1255.59v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-16",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M697.85,1239.91v-2.04h2.17v2.04h-2.17ZM697.85,1255.59v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-3",
    "data-name": "aq",
    className: "emails-phase-3-18",
    d: "M708.92,1255.59h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-24",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M720.6,1242.42c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM724.13,1247.92c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M584.44,1183.55h-1v-29.55h1v29.55ZM584.44,1124.65h-1v-34h1v34ZM584.44,1090.65h-1v-3.5h1v3.5Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-14",
    d: "M583.94,1198.33l-4.63-14.27h9.28l-4.65,14.27Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M583.94,1199.95l-5.32-16.4h10.65l-5.33,16.4ZM580,1184.55l3.94,12.16,3.96-12.16h-7.9Z"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bS",
    className: "emails-phase-3-16",
    d: "M539.07,1135.73c0,3.6,1.43,5.91,4.96,5.98,2.51.07,3.67-1.49,4.41-3.19l3.06,1.15c-1.15,2.85-3.46,4.82-7.47,4.82-5.57,0-8.15-3.12-8.49-8.76-.48-7.47,7.4-10.59,13.31-7.27,1.22.68,1.97,1.97,2.44,3.4l-3.12.81c-.54-1.7-2.04-2.78-4.21-2.78-3.53,0-4.82,2.31-4.89,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bT",
    className: "emails-phase-3-16",
    d: "M564.67,1140.96c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM561.61,1136.28c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bU",
    className: "emails-phase-3-16",
    d: "M574.85,1134.03c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bV",
    className: "emails-phase-3-16",
    d: "M583,1144.02c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bW",
    className: "emails-phase-3-16",
    d: "M584.97,1129.01v-2.51h3.4v2.51h-3.4ZM584.97,1144.22v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bX",
    className: "emails-phase-3-16",
    d: "M598.28,1128.87c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bW-2",
    "data-name": "bW",
    className: "emails-phase-3-16",
    d: "M599.84,1129.01v-2.51h3.4v2.51h-3.4ZM599.84,1144.22v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bT-2",
    "data-name": "bT",
    className: "emails-phase-3-16",
    d: "M617.49,1140.96c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM614.44,1136.28c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bY",
    className: "emails-phase-3-16",
    d: "M624.49,1131.05c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM625.64,1142.18c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M583.6,1403.55h-1v-29.1h1v29.1ZM584.44,1345.11h-1v-45h1v45Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-14",
    d: "M584.44,1300.12h-1v-.5h1v.5Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M584.47,1300.15h-1.05v-.56h1.05v.56ZM583.47,1299.65v.45h.95v-.46h-.95Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-14",
    d: "M583.1,1418.33l-4.64-14.27h9.27l-4.63,14.27Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M583.1,1419.95l-5.33-16.4h10.65l-5.32,16.4ZM579.15,1404.55l3.94,12.16,3.94-12.15h-7.88Z"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bZ",
    className: "emails-phase-3-16",
    d: "M448.81,1364.67l-1.49-4.28h-6.38l-1.49,4.28h-3.53l6.11-16.84h4.14l6.11,16.84h-3.46ZM446.57,1357.74l-2.44-7.33c-.68,2.58-1.63,4.89-2.44,7.33h4.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ca",
    className: "emails-phase-3-16",
    d: "M462.05,1351.49c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM460.62,1362.63c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ca-2",
    "data-name": "ca",
    className: "emails-phase-3-16",
    d: "M476.92,1351.49c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38ZM475.49,1362.63c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bU-2",
    "data-name": "bU",
    className: "emails-phase-3-16",
    d: "M491.79,1354.48c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cb",
    className: "emails-phase-3-16",
    d: "M499.6,1351.49c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM499.53,1362.63c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cc",
    className: "emails-phase-3-16",
    d: "M515.69,1364.67h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bT-3",
    "data-name": "bT",
    className: "emails-phase-3-16",
    d: "M533.14,1361.41c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM530.09,1356.72c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bY-2",
    "data-name": "bY",
    className: "emails-phase-3-16",
    d: "M540.14,1351.49c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72ZM541.29,1362.63c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bX-2",
    "data-name": "bX",
    className: "emails-phase-3-16",
    d: "M564.04,1349.32c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cb-2",
    "data-name": "cb",
    className: "emails-phase-3-16",
    d: "M571.37,1351.49c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM571.3,1362.63c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bU-3",
    "data-name": "bU",
    className: "emails-phase-3-16",
    d: "M587.94,1354.48c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cd",
    className: "emails-phase-3-16",
    d: "M596.7,1347.83c8.15-.48,15.14.34,15.01,8.28-.07,5.43-2.99,8.56-8.22,8.56h-6.79v-16.84ZM600.23,1361.95c5.02.48,7.94-1.22,7.94-5.84s-3.06-5.98-7.94-5.57v11.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bW-3",
    "data-name": "bW",
    className: "emails-phase-3-16",
    d: "M614.35,1349.46v-2.51h3.4v2.51h-3.4ZM614.35,1364.67v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ce",
    className: "emails-phase-3-16",
    d: "M628.75,1355.3c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bV-2",
    "data-name": "bV",
    className: "emails-phase-3-16",
    d: "M640.83,1364.46c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bU-4",
    "data-name": "bU",
    className: "emails-phase-3-16",
    d: "M650.27,1354.48c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bW-4",
    "data-name": "bW",
    className: "emails-phase-3-16",
    d: "M652.31,1349.46v-2.51h3.4v2.51h-3.4ZM652.31,1364.67v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cf",
    className: "emails-phase-3-16",
    d: "M666.57,1351.49c3.53,0,4.75,2.92,4.75,6.65s-1.29,6.72-4.96,6.79c-2.04.07-3.12-1.02-3.94-2.38l-.14,2.1h-3.26l.07-17.72h3.4v7.06c.75-1.56,1.97-2.51,4.07-2.51ZM665.14,1362.63c2.1,0,2.72-1.83,2.72-4.48s-.48-4.28-2.65-4.28-2.78,1.9-2.78,4.41.54,4.35,2.72,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cg",
    className: "emails-phase-3-16",
    d: "M678.04,1364.94c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bV-3",
    "data-name": "bV",
    className: "emails-phase-3-16",
    d: "M694.95,1364.46c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bW-5",
    "data-name": "bW",
    className: "emails-phase-3-16",
    d: "M696.92,1349.46v-2.51h3.4v2.51h-3.4ZM696.92,1364.67v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cb-3",
    "data-name": "cb",
    className: "emails-phase-3-16",
    d: "M709.48,1351.49c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM709.41,1362.63c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ch",
    className: "emails-phase-3-16",
    d: "M726.05,1351.49c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  })))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-13",
    d: "M583.1,1520.11v38.08"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M583.6,1520.12h-1v-.5h1v.5Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-12",
    d: "M583.1,1572.95l-4.64-14.26h9.27l-4.63,14.26Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "rect-9",
    className: "emails-phase-3-4",
    d: "M411.55,1581.07c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-86.67Z"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aJ-3",
    "data-name": "aJ",
    className: "emails-phase-3-18",
    d: "M435.98,1628.44v-15.31h2.1v15.31h-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-13",
    "data-name": "ay",
    className: "emails-phase-3-18",
    d: "M447.34,1616.47c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm-5",
    "data-name": "bm",
    className: "emails-phase-3-18",
    d: "M458.7,1614c-1.91-.56-2.59.62-2.35,2.72h2.35v1.42h-2.35v10.31h-1.91v-10.31h-1.67v-1.42h1.67c-.43-3.21,1.05-5.06,4.26-4.2v1.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-11",
    "data-name": "aC",
    className: "emails-phase-3-18",
    d: "M464.81,1616.47c3.83-.06,5.25,2.28,5.25,6.11.06,3.89-1.67,6.11-5.31,6.11s-5.12-2.41-5.19-6.11c0-4.07,1.73-6.11,5.25-6.11ZM464.75,1627.21c2.72.06,3.27-1.91,3.27-4.63s-.49-4.63-3.15-4.63-3.27,1.98-3.27,4.63.62,4.57,3.15,4.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-10",
    "data-name": "aZ",
    className: "emails-phase-3-18",
    d: "M478.02,1618.38c-4.81-.99-3.27,5.62-3.52,10.06h-1.98l-.06-11.73h1.85c.06.74-.06,1.79.12,2.41.37-1.67,1.42-3.02,3.58-2.53v1.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-6",
    "data-name": "aE",
    className: "emails-phase-3-18",
    d: "M491.29,1618.01c-4.14.19-2.35,6.48-2.72,10.43h-1.91v-7.47c0-1.79-.31-3.09-2.16-2.96-4.07.25-2.35,6.42-2.72,10.43h-1.91l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.62-2.72,6.11-3.09,6.6,0,.68-1.3,1.67-2.16,3.58-2.22,5.25-.12,2.9,7.35,3.4,11.98h-1.91v-7.47c0-1.79-.31-3.02-2.16-2.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bk-3",
    "data-name": "bk",
    className: "emails-phase-3-18",
    d: "M516.04,1617.39c-.62-1.73-2.16-2.78-4.51-2.78-3.64,0-5.37,2.47-5.37,6.11s1.79,6.23,5.49,6.23c2.65,0,3.83-1.48,4.81-3.21l1.67.86c-1.11,2.35-3.15,4.07-6.6,4.07-4.94,0-7.22-3.09-7.47-7.96-.37-6.42,6.11-9.44,11.54-6.85,1.17.56,1.91,1.6,2.41,2.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-4",
    "data-name": "aI",
    className: "emails-phase-3-18",
    d: "M524.13,1628.69c-5.49.25-3.33-7.16-3.77-11.98h1.98v7.41c0,1.91.43,3.09,2.41,3.02,4.44-.12,2.78-6.23,3.09-10.43h1.91l.06,11.73h-1.85c-.06-.62.06-1.54-.12-2.04-.68,1.36-1.73,2.22-3.7,2.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-12",
    "data-name": "as",
    className: "emails-phase-3-18",
    d: "M539.63,1619.61c-.19-2.1-5.31-2.35-5.37,0,.93,3.27,7.1.74,7.35,5.56s-9.26,4.57-9.69.49l1.73-.31c.25,2.22,5.99,2.78,6.05,0-.62-3.46-6.98-.93-7.28-5.56-.25-3.52,5.06-3.89,7.53-2.59.74.43,1.3,1.17,1.48,2.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-19",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M546.04,1625.54c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-12",
    "data-name": "aC",
    className: "emails-phase-3-18",
    d: "M554.75,1616.47c3.83-.06,5.25,2.28,5.25,6.11.06,3.89-1.67,6.11-5.31,6.11s-5.12-2.41-5.19-6.11c0-4.07,1.73-6.11,5.25-6.11ZM554.69,1627.21c2.72.06,3.27-1.91,3.27-4.63s-.49-4.63-3.15-4.63-3.27,1.98-3.27,4.63.62,4.57,3.15,4.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-7",
    "data-name": "aE",
    className: "emails-phase-3-18",
    d: "M573.88,1618.01c-4.14.19-2.35,6.48-2.72,10.43h-1.91v-7.47c0-1.79-.31-3.09-2.16-2.96-4.07.25-2.35,6.42-2.72,10.43h-1.91l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.62-2.72,6.11-3.09,6.6,0,.68-1.3,1.67-2.16,3.58-2.22,5.25-.12,2.9,7.35,3.4,11.98h-1.91v-7.47c0-1.79-.31-3.02-2.16-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-25",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M585.55,1616.47c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM588.76,1621.47c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-11",
    "data-name": "aZ",
    className: "emails-phase-3-18",
    d: "M598.76,1618.38c-4.81-.99-3.27,5.62-3.52,10.06h-1.98l-.06-11.73h1.85c.06.74-.06,1.79.12,2.41.37-1.67,1.42-3.02,3.58-2.53v1.79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bO-2",
    "data-name": "bO",
    className: "emails-phase-3-18",
    d: "M609.13,1614.86v5.68h8.52v1.73h-8.52v6.17h-2.04v-15.31h10.8v1.73h-8.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-15",
    "data-name": "aw",
    className: "emails-phase-3-18",
    d: "M627.46,1626.22c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM621.72,1625.17c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-7",
    "data-name": "az",
    className: "emails-phase-3-18",
    d: "M637.03,1618.01c-2.47,0-2.96,2.04-2.96,4.51s.56,4.63,2.96,4.63c1.48,0,2.53-.86,2.65-2.35l1.98.12c-.37,2.28-1.91,3.77-4.57,3.77-3.64,0-4.69-2.53-5.06-6.11-.62-5.74,6.23-8.09,9.07-3.95.25.43.31.86.43,1.36l-1.98.19c-.25-1.3-.99-2.16-2.53-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-17",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M643.7,1614.18v-1.85h1.98v1.85h-1.98ZM643.7,1628.44v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-14",
    "data-name": "ay",
    className: "emails-phase-3-18",
    d: "M654.32,1616.47c5.49-.25,3.27,7.16,3.7,11.98h-1.98v-7.47c0-1.91-.49-3.02-2.41-2.96-4.44.12-2.72,6.3-3.02,10.43h-1.98l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.68-1.36,1.79-2.16,3.77-2.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-5",
    "data-name": "ax",
    className: "emails-phase-3-18",
    d: "M670.37,1616.71c-.62,7.72,2.53,18.09-6.79,16.11-1.42-.37-2.35-1.23-2.72-2.65l1.98-.31c.93,2.9,6.17,1.98,5.49-1.73v-1.85c-.68,1.3-1.79,2.22-3.77,2.22-3.33,0-4.2-2.53-4.2-5.93s.99-5.99,4.38-6.05c1.79-.06,2.96.99,3.64,2.16.06-.62,0-1.42.12-1.98h1.85ZM665.24,1627.08c2.22,0,3.09-1.98,3.09-4.51s-.86-4.63-3.09-4.63c-2.41,0-2.84,2.1-2.84,4.63s.37,4.51,2.84,4.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aY-4",
    "data-name": "aY",
    className: "emails-phase-3-18",
    d: "M685.8,1614.86v13.58h-2.1v-13.58h-5.25v-1.73h12.59v1.73h-5.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-26",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M695.18,1616.47c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM698.39,1621.47c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-16",
    "data-name": "aw",
    className: "emails-phase-3-18",
    d: "M710.06,1626.22c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM704.32,1625.17c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-8",
    "data-name": "aE",
    className: "emails-phase-3-18",
    d: "M726.66,1618.01c-4.14.19-2.35,6.48-2.72,10.43h-1.91v-7.47c0-1.79-.31-3.09-2.16-2.96-4.07.25-2.35,6.42-2.72,10.43h-1.91l-.06-11.73h1.85c.06.62-.06,1.48.12,1.98.62-2.72,6.11-3.09,6.6,0,.68-1.3,1.67-2.16,3.58-2.22,5.25-.12,2.9,7.35,3.4,11.98h-1.91v-7.47c0-1.79-.31-3.02-2.16-2.96"
  })))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-9",
    d: "M1137.3,306.73v177.57h-361.97"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M1138.8,306.77h-3v-1.54h3v1.54Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-11",
    d: "M759.57,484.3l14.27-4.63v9.27l-14.27-4.64Z"
  })), _a || (_a = /*#__PURE__*/React.createElement("a", {
    xlinkHref: "#soa-email-popup-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-20",
    d: "M336.9,1228.81h32.06v20.28h-32.06v-20.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-17",
    d: "M336.9,1249.2h32.04v20.87h-32.04v-20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-2",
    d: "M368.96,1228.81h32.96v20.87h-32.96v-20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-21",
    d: "M368.96,1249.2h32.96v20.87h-32.96v-20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-1",
    d: "M335,1237.91h33.94v2.67h-33.94v-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-1",
    d: "M351.03,1228.77v20.32h-2.96v-20.32h2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-6",
    d: "M383.76,1228.88v20.32h-3.42v-20.32h3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-6",
    d: "M401.73,1241.05h-32.83v-3.42h32.83v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-5",
    d: "M351.2,1249.18v20.96h-3.4v-20.97h3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-5",
    d: "M369,1261.91h-32.1v-3.42h32.1v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-1",
    d: "M383.76,1249.09v20.96h-3.42v-20.96h3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-1",
    d: "M401.92,1261.91h-33.02v-3.42h33.02v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-6",
    d: "M383.1,1249.1v21h-2.1v-21h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-6",
    d: "M401.95,1261.25h-33v-2.08h33v2.08Z"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "rect-4",
    className: "emails-phase-3-4",
    d: "M412.82,608.91c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v91.45c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-91.45Z"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    id: "au-6",
    "data-name": "au",
    className: "emails-phase-3-18",
    d: "M466.68,646.94c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-4",
    "data-name": "av",
    className: "emails-phase-3-18",
    d: "M479.92,642.73c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM479.92,658.14c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-5",
    "data-name": "ao",
    className: "emails-phase-3-18",
    d: "M503.35,659.77l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM500.77,653.05l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "al"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bP-2",
    "data-name": "bP",
    className: "emails-phase-3-18",
    d: "M518.96,646.6c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM518.42,658.41c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ-12",
    "data-name": "aZ",
    className: "emails-phase-3-18",
    d: "M532.48,648.7c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-13",
    "data-name": "aC",
    className: "emails-phase-3-18",
    d: "M539.61,646.6c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM539.54,658.41c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-4",
    "data-name": "aq",
    className: "emails-phase-3-18",
    d: "M553.73,659.77h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-18",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M560.25,644.09v-2.04h2.17v2.04h-2.17ZM560.25,659.77v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-7",
    "data-name": "ap",
    className: "emails-phase-3-18",
    d: "M569.75,646.6c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM570.36,648.23c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-27",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M584.35,646.6c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM587.88,652.1c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-13",
    "data-name": "as",
    className: "emails-phase-3-18",
    d: "M600.31,650.06c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aB-20",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M614.16,656.58c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-28",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M623.74,646.6c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM627.27,652.1c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-14",
    "data-name": "as",
    className: "emails-phase-3-18",
    d: "M639.69,650.06c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-21",
    "data-name": "aB",
    className: "emails-phase-3-18",
    d: "M646.75,656.58c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "an"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at-29",
    "data-name": "at",
    className: "emails-phase-3-18",
    d: "M663.12,646.6c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM666.65,652.1c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-9",
    "data-name": "aE",
    className: "emails-phase-3-18",
    d: "M684.17,648.3c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-17",
    "data-name": "aw",
    className: "emails-phase-3-18",
    d: "M699.78,657.33c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM693.47,656.17c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-19",
    "data-name": "ar",
    className: "emails-phase-3-18",
    d: "M705.42,644.09v-2.04h2.17v2.04h-2.17ZM705.42,659.77v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF-4",
    "data-name": "aF",
    className: "emails-phase-3-18",
    d: "M710.78,659.77v-17.72h2.17v17.72h-2.17"
  })))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-13",
    d: "M583.94,707.35l-.63,49"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-8",
    d: "M584.44,707.38h-1v-.52h1v.52Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "emails-phase-3-12",
    d: "M583.1,771.12l-4.44-14.33,9.27.12-4.83,14.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoaEmail3);
export default __webpack_public_path__ + "static/media/SOA-EMAIL-3.3818ad74b342cb7ca9761b68816fd53b.svg";
export { ForwardRef as ReactComponent };